import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment } from 'react';
import ReactCountryFlag from 'react-country-flag';

interface MovablePlaceholderProps {
  label: string;
  showSmall: boolean;
  icon?: any;
  flag?: string;
  emptyIcon?: boolean;
}

const MovablePlaceholder: FC<MovablePlaceholderProps> = ({
  label,
  showSmall,
  icon,
  flag,
  emptyIcon,
}) => {
  return (
    <Fragment>
      <span className="movable-placeholder-icon">
        {icon && <FontAwesomeIcon icon={icon as unknown as any} />}
        {flag && <ReactCountryFlag svg countryCode={flag} />}
      </span>
      <div
        className={
          'movable-placeholder' +
          (showSmall ? ' small' : '') +
          (!icon && !flag && !emptyIcon ? ' noicon' : '')
        }
      >
        <span>{label}</span>
      </div>
    </Fragment>
  );
};

export default MovablePlaceholder;
